// import React, { useState, useCallback } from 'react';
// import axios from 'axios';
// import {
//     Box,
//     Button,
//     TextField,
//     Typography,
//     Paper,
//     LinearProgress,
//     Alert,
//     Stack,
//     IconButton
// } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import ClearIcon from '@mui/icons-material/Clear';
// import { useTheme } from '@mui/material/styles';
// import { toast } from 'react-toastify';
// import { v4 as uuidv4 } from 'uuid';
// import { CREATE_SCORM_COURSE } from 'helpers/url_helper';
// import { generatePreSignedUrl } from 'helpers/Content_helper';

// const ScormUpload = ({ onUploadSuccess }) => {
//     const [file, setFile] = useState(null);
//     const [title, setTitle] = useState('');
//     const [uploading, setUploading] = useState(false);
//     const [apiError, setApiError] = useState('');
//     const [validationErrors, setValidationErrors] = useState({});
//     const [isDragOver, setIsDragOver] = useState(false);
//     const [thumbnail, setThumbnail] = useState("");
//     const theme = useTheme();

//     // --- Form Validation ---
//     const validate = () => {
//         const errors = {};
//         if (!title.trim()) errors.title = 'Course title is required.';
//         if (!file) errors.file = 'Please select a .zip file to upload.';
//         setValidationErrors(errors);
//         return Object.keys(errors).length === 0;
//     };

//     // --- File Handlers ---
//     const handleFileChange = (e) => {
//         const selectedFile = e.target.files?.[0];
//         if (selectedFile) {
//             setFile(selectedFile);
//             if (validationErrors.file) {
//                 setValidationErrors(prev => ({ ...prev, file: '' }));
//             }
//         }
//     };

//     const handleThumbnailChange = (e) => {
//         const selectedFile = e.target.files?.[0];
//         if (selectedFile) {
//             setThumbnail(selectedFile);
//             if (validationErrors.thumbnail) {
//                 setValidationErrors(prev => ({ ...prev, thumbnail: '' }));
//             }
//         }
//     };

//     const handleClearFile = () => setFile(null);
//     const handleClearThumbnail = () => setThumbnail(null);

//     // --- Drag and Drop Handlers ---
//     const handleDragOver = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         setIsDragOver(true);
//     }, []);

//     const handleDragLeave = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         setIsDragOver(false);
//     }, []);

//     const handleDrop = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         setIsDragOver(false);
//         const droppedFile = e.dataTransfer.files?.[0];
//         if (droppedFile && droppedFile.name.endsWith('.zip')) {
//             setFile(droppedFile);
//             if (validationErrors.file) {
//                 setValidationErrors(prev => ({ ...prev, file: '' }));
//             }
//         } else {
//             toast.error("Invalid file type. Please drop a .zip file.");
//         }
//     }, [validationErrors.file]);


//     // --- Upload Logic ---
//     const handleUpload = async () => {
//         setApiError('');
//         if (!validate()) return;
//         try {
//             setUploading(true);
//             const thumbnailName = await uploadData(thumbnail, "image");

//             const formData = new FormData();
//             formData.append('file', file);
//             formData.append('title', title);
//             formData.append('thumbnail', thumbnailName);

//             const authUser = localStorage.getItem('authUser');
//             const organizationId = JSON.parse(authUser)?.organizationId;


//             const { data } = await axios.post(CREATE_SCORM_COURSE, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                     'X-Organization-ID': organizationId
//                 },
//             });

//             if (data?.success) {
//                 toast.success(data.message || 'Course uploaded successfully!');
//                 // Reset form and notify parent
//                 setTitle('');
//                 setFile(null);
//                 setValidationErrors({});
//                 if (onUploadSuccess) onUploadSuccess(data.result);
//             } else {
//                 throw new Error(data.message || 'An unknown error occurred.');
//             }
//         } catch (err) {
//             const errorMessage = err.response?.data?.message || err.message;
//             console.error('Upload failed:', errorMessage);
//             setApiError(errorMessage);
//         } finally {
//             setUploading(false);
//         }
//     };

//     const uploadData = (file, type) => {
//         console.log("Entering uploadData");
//         return new Promise(async (resolve, reject) => {
//             try {
//                 const name = uuidv4() + '.' + file.name.split('.').pop();
//                 // Request a pre-signed URL from the backend
//                 console.log("name ---> ", name);
//                 const result = await generatePreSignedUrl({ name, type });

//                 if (result?.success) {
//                     const url = result?.presignedUrl; // Assuming your backend returns URL and headers for PUT request
//                     console.log("Presigned URL: ", url);

//                     // Upload the file to S3 using the pre-signed URL
//                     const res = await axios.put(url, file, {
//                         headers: {
//                             'Content-Type': file.type,
//                         },
//                     });
//                     console.log("s3 Upload result: ", res);

//                     resolve(name);
//                 } else {
//                     reject(result?.message || 'Failed to get pre-signed URL.');
//                 }
//             } catch (error) {
//                 console.error('Upload error:', error); // Log the error for debugging
//                 reject('Error uploading the file.');
//             }
//         });
//     };

//     return (
//         <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
//             <Stack spacing={3}>
//                 <Typography variant="h5" component="h2" fontWeight="bold">
//                     Create SCORM Course
//                 </Typography>

//                 {apiError && <Alert severity="error">{apiError}</Alert>}

//                 <TextField
//                     fullWidth
//                     label="Course Title"
//                     variant="outlined"
//                     value={title}
//                     onChange={(e) => {
//                         setTitle(e.target.value);
//                         if (validationErrors.title) {
//                             setValidationErrors(prev => ({ ...prev, title: '' }));
//                         }
//                     }}
//                     error={!!validationErrors.title}
//                     helperText={validationErrors.title}
//                     disabled={uploading}
//                 />

//                 {!thumbnail ? (
//                     <Box
//                         sx={{
//                             border: `2px dashed ${validationErrors.thumbnail ? theme.palette.error.main : theme.palette.grey[400]}`,
//                             borderRadius: 1,
//                             p: 3,
//                             textAlign: 'center',
//                         }}
//                     >
//                         <Typography variant="h6">Upload Course Thumbnail</Typography>
//                         <Button
//                             component="label"
//                             variant="outlined"
//                             sx={{ mt: 1 }}
//                             disabled={uploading}
//                         >
//                             Select Image
//                             <input type="file" accept="image/*" hidden onChange={handleThumbnailChange} />
//                         </Button>
//                         {validationErrors.thumbnail && (
//                             <Typography color="error" variant="caption" display="block" mt={1}>
//                                 {validationErrors.thumbnail}
//                             </Typography>
//                         )}
//                     </Box>
//                 ) : (
//                     <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
//                         <InsertDriveFileIcon color="primary" />
//                         <Typography variant="body1" sx={{ flexGrow: 1 }}>
//                             {thumbnail.name}
//                         </Typography>
//                         <IconButton onClick={handleClearThumbnail} disabled={uploading} size="small">
//                             <ClearIcon />
//                         </IconButton>
//                     </Paper>
//                 )}

//                 {!file ? (
//                     <Box
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         onDrop={handleDrop}
//                         sx={{
//                             border: `2px dashed ${validationErrors.file ? theme.palette.error.main : theme.palette.grey[400]}`,
//                             borderRadius: 1,
//                             p: 4,
//                             textAlign: 'center',
//                             backgroundColor: isDragOver ? theme.palette.action.hover : 'transparent',
//                             transition: 'background-color 0.2s ease-in-out',
//                         }}
//                     >
//                         <CloudUploadIcon sx={{ fontSize: 48, color: 'grey.500' }} />
//                         <Typography variant="h6" my={1}>
//                             Drag & drop a .zip file here
//                         </Typography>
//                         <Typography color="text.secondary">or</Typography>
//                         <Button
//                             component="label"
//                             variant="outlined"
//                             disabled={uploading}
//                             sx={{ mt: 1 }}
//                         >
//                             Select File
//                             <input type="file" accept=".zip" hidden onChange={handleFileChange} />
//                         </Button>
//                         {validationErrors.file && (
//                             <Typography color="error" variant="caption" display="block" mt={1}>{validationErrors.file}</Typography>
//                         )}
//                     </Box>
//                 ) : (
//                     <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
//                         <InsertDriveFileIcon color="primary" />
//                         <Typography variant="body1" sx={{ flexGrow: 1 }}>
//                             {file.name}
//                         </Typography>
//                         <IconButton onClick={handleClearFile} disabled={uploading} size="small">
//                             <ClearIcon />
//                         </IconButton>
//                     </Paper>
//                 )}

//                 <Box>
//                     {uploading && <LinearProgress sx={{ mb: 1 }} />}
//                     <Button
//                         fullWidth
//                         variant="contained"
//                         size="large"
//                         onClick={handleUpload}
//                         disabled={uploading}
//                         startIcon={<CloudUploadIcon />}
//                     >
//                         {uploading ? 'Uploading...' : 'Upload Course'}
//                     </Button>
//                 </Box>
//             </Stack>
//         </Paper>
//     );
// };

// export default ScormUpload;









import React, { useState, useCallback } from 'react';
import axios from 'axios';
import {
    Box, Button, TextField, Typography, Paper, LinearProgress,
    Alert, Stack, IconButton, Chip,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ClearIcon from '@mui/icons-material/Clear';
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { CREATE_SCORM_COURSE } from 'helpers/url_helper';
import { generatePreSignedUrl } from 'helpers/Content_helper';

const PHASE = {
    IDLE: 'idle',
    THUMBNAIL: 'thumbnail',
    UPLOADING: 'uploading',
    PROCESSING: 'processing',
    DONE: 'done',
};

const ScormUpload = ({ onUploadSuccess }) => {
    const [file, setFile] = useState(null);
    const [title, setTitle] = useState('');
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [phase, setPhase] = useState(PHASE.IDLE);
    const [apiError, setApiError] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const [isDragOver, setIsDragOver] = useState(false);
    const [thumbnail, setThumbnail] = useState('');
    const theme = useTheme();

    const validate = () => {
        const errors = {};
        if (!title.trim()) errors.title = 'Course title is required.';
        if (!file) errors.file = 'Please select a .zip file to upload.';
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFileChange = (e) => {
        const f = e.target.files?.[0];
        if (f) {
            setFile(f);
            if (validationErrors.file) setValidationErrors((p) => ({ ...p, file: '' }));
        }
    };
    const handleThumbnailChange = (e) => {
        const f = e.target.files?.[0];
        if (f) {
            setThumbnail(f);
            if (validationErrors.thumbnail) setValidationErrors((p) => ({ ...p, thumbnail: '' }));
        }
    };
    const handleClearFile = () => setFile(null);
    const handleClearThumbnail = () => setThumbnail(null);

    const handleDragOver = useCallback((e) => {
        e.preventDefault(); e.stopPropagation(); setIsDragOver(true);
    }, []);
    const handleDragLeave = useCallback((e) => {
        e.preventDefault(); e.stopPropagation(); setIsDragOver(false);
    }, []);
    const handleDrop = useCallback((e) => {
        e.preventDefault(); e.stopPropagation(); setIsDragOver(false);
        const f = e.dataTransfer.files?.[0];
        if (f && f.name.endsWith('.zip')) {
            setFile(f);
            if (validationErrors.file) setValidationErrors((p) => ({ ...p, file: '' }));
        } else {
            toast.error('Invalid file type. Please drop a .zip file.');
        }
    }, [validationErrors.file]);

    const uploadThumbnail = (thumbFile) => new Promise(async (resolve, reject) => {
        try {
            const name = uuidv4() + '.' + thumbFile.name.split('.').pop();
            const result = await generatePreSignedUrl({ name, type: 'image' });
            if (result?.success) {
                await axios.put(result.presignedUrl, thumbFile, {
                    headers: { 'Content-Type': thumbFile.type },
                    timeout: 0,
                    maxBodyLength: Infinity,
                    maxContentLength: Infinity,
                });
                resolve(name);
            } else {
                reject(result?.message || 'Failed to get pre-signed URL.');
            }
        } catch (err) {
            console.error('Thumbnail upload error:', err);
            reject('Error uploading thumbnail.');
        }
    });

    const handleUpload = async () => {
        setApiError('');
        if (!validate()) return;

        try {
            setUploading(true);
            setUploadProgress(0);

            let thumbnailName = '';
            if (thumbnail) {
                setPhase(PHASE.THUMBNAIL);
                thumbnailName = await uploadThumbnail(thumbnail);
            }

            setPhase(PHASE.UPLOADING);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('title', title);
            formData.append('thumbnail', thumbnailName);

            const organizationId = JSON.parse(localStorage.getItem('authUser'))?.organizationId;

            const { data } = await axios.post(CREATE_SCORM_COURSE, formData, {
                headers: {
                    'X-Organization-ID': organizationId,
                },
                timeout: 0,
                maxBodyLength: Infinity,
                maxContentLength: Infinity,
                onUploadProgress: (e) => {
                    if (e.total) {
                        const pct = Math.round((e.loaded * 100) / e.total);
                        setUploadProgress(pct);
                        if (pct >= 100) setPhase(PHASE.PROCESSING);
                    }
                },
            });

            setPhase(PHASE.DONE);

            if (data?.success) {
                toast.success(data.message || 'Course uploaded successfully!');
                setTitle('');
                setFile(null);
                setThumbnail(null);
                setValidationErrors({});
                if (onUploadSuccess) onUploadSuccess(data.result);
            } else {
                throw new Error(data.message || 'An unknown error occurred.');
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message;
            console.error('Upload failed:', msg);
            setApiError(msg);
        } finally {
            setUploading(false);
            setPhase(PHASE.IDLE);
            setUploadProgress(0);
        }
    };

    const phaseLabel = () => {
        switch (phase) {
            case PHASE.THUMBNAIL: return 'Uploading thumbnail…';
            case PHASE.UPLOADING: return `Uploading package… ${uploadProgress}%`;
            case PHASE.PROCESSING: return 'Processing package on server (scanning manifest, uploading files to S3)…';
            case PHASE.DONE: return 'Finalizing…';
            default: return '';
        }
    };

    const isDeterminate = phase === PHASE.UPLOADING;

    return (
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Stack spacing={3}>
                <Typography variant="h5" component="h2" fontWeight="bold">
                    Create SCORM Course
                </Typography>

                {apiError && <Alert severity="error">{apiError}</Alert>}

                <TextField
                    fullWidth label="Course Title" variant="outlined"
                    value={title}
                    onChange={(e) => {
                        setTitle(e.target.value);
                        if (validationErrors.title) setValidationErrors((p) => ({ ...p, title: '' }));
                    }}
                    error={!!validationErrors.title}
                    helperText={validationErrors.title}
                    disabled={uploading}
                />

                {!thumbnail ? (
                    <Box sx={{
                        border: `2px dashed ${validationErrors.thumbnail
                            ? theme.palette.error.main : theme.palette.grey[400]}`,
                        borderRadius: 1, p: 3, textAlign: 'center',
                    }}>
                        <Typography variant="h6">Upload Course Thumbnail</Typography>
                        <Button component="label" variant="outlined" sx={{ mt: 1 }} disabled={uploading}>
                            Select Image
                            <input type="file" accept="image/*" hidden onChange={handleThumbnailChange} />
                        </Button>
                        {validationErrors.thumbnail && (
                            <Typography color="error" variant="caption" display="block" mt={1}>
                                {validationErrors.thumbnail}
                            </Typography>
                        )}
                    </Box>
                ) : (
                    <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <InsertDriveFileIcon color="primary" />
                        <Typography variant="body1" sx={{ flexGrow: 1 }}>{thumbnail.name}</Typography>
                        <IconButton onClick={handleClearThumbnail} disabled={uploading} size="small">
                            <ClearIcon />
                        </IconButton>
                    </Paper>
                )}

                {!file ? (
                    <Box
                        onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}
                        sx={{
                            border: `2px dashed ${validationErrors.file
                                ? theme.palette.error.main : theme.palette.grey[400]}`,
                            borderRadius: 1, p: 4, textAlign: 'center',
                            backgroundColor: isDragOver ? theme.palette.action.hover : 'transparent',
                            transition: 'background-color 0.2s ease-in-out',
                        }}
                    >
                        <CloudUploadIcon sx={{ fontSize: 48, color: 'grey.500' }} />
                        <Typography variant="h6" my={1}>Drag & drop a .zip file here</Typography>
                        <Typography color="text.secondary">or</Typography>
                        <Button component="label" variant="outlined" disabled={uploading} sx={{ mt: 1 }}>
                            Select File
                            <input type="file" accept=".zip" hidden onChange={handleFileChange} />
                        </Button>
                        {validationErrors.file && (
                            <Typography color="error" variant="caption" display="block" mt={1}>
                                {validationErrors.file}
                            </Typography>
                        )}
                    </Box>
                ) : (
                    <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <InsertDriveFileIcon color="primary" />
                        <Typography variant="body1" sx={{ flexGrow: 1 }}>{file.name}</Typography>
                        <Chip
                            size="small"
                            label={`${(file.size / (1024 * 1024)).toFixed(2)} MB`}
                            variant="outlined"
                        />
                        <IconButton onClick={handleClearFile} disabled={uploading} size="small">
                            <ClearIcon />
                        </IconButton>
                    </Paper>
                )}

                <Box>
                    {uploading && (
                        <Box sx={{ mb: 1 }}>
                            <LinearProgress
                                variant={isDeterminate ? 'determinate' : 'indeterminate'}
                                value={isDeterminate ? uploadProgress : undefined}
                            />
                            <Typography
                                variant="caption"
                                display="block"
                                textAlign="center"
                                mt={0.5}
                                color={phase === PHASE.PROCESSING ? 'primary' : 'text.secondary'}
                            >
                                {phaseLabel()}
                            </Typography>
                        </Box>
                    )}
                    <Button
                        fullWidth variant="contained" size="large"
                        onClick={handleUpload} disabled={uploading}
                        startIcon={<CloudUploadIcon />}
                    >
                        {uploading ? phaseLabel() || 'Uploading…' : 'Upload Course'}
                    </Button>
                </Box>
            </Stack>
        </Paper>
    );
};

export default ScormUpload;